import { Box, Typography } from '@mui/material';
import { COLORS } from '../../Styles/Colors';

interface InventoryBarProps {
  current: number;
  capacity: number | null;
  stockLevel?: string;
}

const levelColor = (pct: number, stockLevel?: string) => {
  if (stockLevel === 'empty' || pct <= 0) return COLORS.red;
  if (stockLevel === 'low' || pct < 25) return COLORS.orange;
  return COLORS.success;
};

export const InventoryBar = ({ current, capacity, stockLevel }: InventoryBarProps) => {
  const cap = capacity && capacity > 0 ? capacity : null;
  const pct = cap ? Math.min(100, Math.round((current / cap) * 100)) : 0;
  const color = levelColor(pct, stockLevel);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
      }}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          height: 8,
          borderRadius: 1,
          backgroundColor: `${COLORS.lightGray}30`,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            width: `${pct}%`,
            height: '100%',
            backgroundColor: color,
            transition: 'width 0.25s ease',
            borderRadius: 1,
            minWidth: pct > 0 ? 4 : 0,
          }}
        />
      </Box>
      <Typography
        variant="caption"
        fontWeight={700}
        sx={{ color, flexShrink: 0, minWidth: 32, textAlign: 'right', lineHeight: 1 }}
      >
        {cap ? `${pct}%` : '—'}
      </Typography>
    </Box>
  );
};

export default InventoryBar;
